import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { HttpClient, HttpHeaders } from "@angular/common/http";

import { StorageService } from './storage.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable()
export class VaLauncherService {

  constructor(private http: HttpClient, private storageService: StorageService) {

  }

  //create release
  // createRelease(id, params) {
  //   return this.http.post(environment.va_launcher_api + "releases/" + id + "/va_release", params).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  createRelease(id, params) {
    return this.http.post(environment.va_launcher_api + "releases/" + id + "/va_release", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //get all releases
  // getReleases(id) {
  //   return this.http.get(environment.va_launcher_api + "releases/" + id + "/va_release").map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  getReleases(id) {
    return this.http.get(environment.va_launcher_api + "releases/" + id + "/va_release")
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //set current release id in localstorage
  setReleaseId(release){
    this.storageService.store('release', release)
    // localStorage.setItem('release',JSON.stringify(release));
  }
  //update release
  // updateRelease(id, params) {
  //   return this.http.put(environment.va_launcher_api + "releases/" + id + "/va_release", params).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  updateRelease(id, params) {
    return this.http.put(environment.va_launcher_api + "releases/" + id + "/va_release", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //upload release
  // importRelease(id,file){
  //   // const formData: FormData = new FormData();
  //   // formData.append('file', file, file.name);
  //   return this.http.post(environment.va_launcher_api+"releases/"+id+"/restore",file,{
  //     headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
  //   }).map((response)=>{
  //     return response;
  //   },
  //   (err: Response) => {
  //     console.log(err);
  //     return err;
  //   });
  // }
  importRelease(id, file) {
    // const formData: FormData = new FormData();
    // formData.append('file', file, file.name);
    return this.http.post(environment.va_launcher_api + "releases/" + id + "/restore", file, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
    })
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  /*Release History*/
  // getReleaseHistory(id,param){
  //   return this.http.get(environment.va_launcher_api + "releases/"+id+"/release_history?release_id="+ param.release_id)
  //   .map((response: Response) => {
  //     return response
  //   },
  //     (err: Response) => {
  //       console.log(err)
  //       return err
  //     });
  // }
  getReleaseHistory(id, param) {
    return this.http.get(environment.va_launcher_api + "releases/" + id + "/release_history?release_id=" + param.release_id)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  
  // getPreviousReleaseHistory(agent_id,release_id){
  //   return this.http.get(environment.va_launcher_api + "releases/"+agent_id+"/previous_release_history?release_id="+ release_id)
  //   .map((response: Response) => {
  //     return response
  //   },
  //     (err: Response) => {
  //       console.log(err)
  //       return err
  //     });
  // }
  getPreviousReleaseHistory(agent_id, release_id) {
    return this.http.get(environment.va_launcher_api + "releases/" + agent_id + "/previous_release_history?release_id=" + release_id)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //delete release
  // deleteRelease(id, va_id) {
  //   return this.http.delete(environment.va_launcher_api + "releases/" + id + "/va_release/" + va_id).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  deleteRelease(id, va_id) {
    return this.http.delete(environment.va_launcher_api + "releases/" + id + "/va_release/" + va_id)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //va launch production
  // launchVA(id, params) {
  //   return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/launch", params).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  launchVA(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/launch", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // getMasterReleaseData(agent_id){
  //   return this.http.get(environment.va_launcher_api + "releases/" + agent_id + "/master_release", {})
  //   .map((response: Response) => {
  //     return response
  //   },
  //     (err: Response) => {
  //       console.log(err)
  //       return err
  //     });
  // }
  getMasterReleaseData(agent_id) {
    return this.http.get(environment.va_launcher_api + "releases/" + agent_id + "/master_release", {})
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //va stop
  // stopVA(id, params) {
  //   return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/stop", params)
  //     .map((response: Response) => {
  //       return response
  //     },
  //       (err: Response) => {
  //         console.log(err)
  //         return err
  //       });
  // }
  stopVA(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/stop", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //va restart
  // restartVA(id, params) {
  //   return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/restart", params)
  //     .map((response: Response) => {
  //       return response
  //     },
  //       (err: Response) => {
  //         console.log(err)
  //         return err
  //       });
  // }
  restartVA(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/restart", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }
  //check task status
  // taskStatus(id, task_id) {
  //   return this.http.get(environment.va_launcher_api + "mas_launcher/" + id + "/status/" + task_id, {})
  //     .map((response: Response) => {
  //       return response
  //     },
  //       (err: Response) => {
  //         console.log(err)
  //         return err
  //       });
  // }
  taskStatus(id, task_id) {
    return this.http.get(environment.va_launcher_api + "mas_launcher/" + id + "/status/" + task_id, {})
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // Get multi launch server details
  // getMultiLaunchServer(id: any) {
  //   return this.http.get(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/status").map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  getMultiLaunchServer(id: any) {
    return this.http.get(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/status")
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // stop single multi launch server 
  // stopSingleServer(id: any, destination_id: any, number:any) {
  //   return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/stop/" + destination_id + "/" +number, {}).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  stopSingleServer(id: any, destination_id: any, number: any) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/stop/" + destination_id + "/" + number, {})
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // start single multi launch server 
  // startSingleServer(id: any, destination_id: any, number:any) {
  //   return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/start/" + destination_id + "/" +number, {}).map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //       return err;
  //     });
  // }
  startSingleServer(id: any, destination_id: any, number: any) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/deploy/start/" + destination_id + "/" + number, {})
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // get launch destination config
  // getLaunchDestinationConfig(id){
  //   return this.http.get(environment.va_launcher_api + "mas_launcher/"+ id +"/launch_destinations").map(
  //     (response : Response)=>{
  //       return response; 
  //     },
  //     (err: Response)=>{
  //       console.log(err);
  //       return err
  //     });
  // }
  getLaunchDestinationConfig(id) {
    return this.http.get(environment.va_launcher_api + "mas_launcher/" + id + "/launch_destinations")
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // set launch destination config
  // setLaunchDestinationConfig(id,params){
  //   return this.http.put(environment.va_launcher_api+"mas_launcher/"+id +"/launch_destinations/config",params).map(
  //     (response :Response)=>{
  //     return response;
  //   },
  //   (err:Response)=>{
  //     console.log(err);
  //     return err;
  //   })
  // }
  setLaunchDestinationConfig(id, params) {
    return this.http.put(environment.va_launcher_api + "mas_launcher/" + id + "/launch_destinations/config", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // add launch destination server

  // addLaunchDestinationServer(id,params){
  //   return this.http.post(environment.va_launcher_api+"mas_launcher/"+id +"/launch_destinations/servers",params).map(
  //     (response :Response)=>{
  //     return response;
  //   },
  //   (err:Response)=>{
  //     console.log(err);
  //     return err;
  //   })
  // }
  addLaunchDestinationServer(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/launch_destinations/servers", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // update launch destination server

  // updateLaunchDestinationServer(id,value){
  //   let params={
  //     "name": value.name,
  //     "environment": value.environment,
  //     "docker_client":value.docker_client,
  //     "enabled": value.enabled,
  //     "count": value.count,
      
  //   }
   
  //   return this.http.put(environment.va_launcher_api+"mas_launcher/"+id +"/launch_destinations/servers/"+ value.id,params).map(
  //     (response :Response)=>{
  //     return response;
  //   },
  //   (err:Response)=>{
  //     console.log(err);
  //     return err;
  //   })
  // }
  updateLaunchDestinationServer(id, value) {
    let params = {
      "name": value.name,
      "environment": value.environment,
      "docker_client": value.docker_client,
      "enabled": value.enabled,
      "count": value.count,
    };
  
    return this.http.put(environment.va_launcher_api + "mas_launcher/" + id + "/launch_destinations/servers/" + value.id, params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // delete launch destination server
  // deleteLaunchDestinationServer(id,params){
  //   return this.http.delete(environment.va_launcher_api+"mas_launcher/"+id +"/launch_destinations/servers/"+ params).map(
  //     (response :Response)=>{
  //     return response;
  //   },
  //   (err:Response)=>{
  //     console.log(err);
  //     return err;
  //   })
  // }
  deleteLaunchDestinationServer(id, params) {
    return this.http.delete(environment.va_launcher_api + "mas_launcher/" + id + "/launch_destinations/servers/" + params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  //va restart
  // commitRelease(id, releaseId, data) {
  //   return this.http.post(environment.va_launcher_api + "releases/" + id +"/va_release/" +releaseId + "/commit", data)
  //     .map((response: Response) => {
  //       return response
  //     },
  //       (err: Response) => {
  //         console.log(err)
  //         return err
  //       });
  // }
  commitRelease(id, releaseId, data) {
    return this.http.post(environment.va_launcher_api + "releases/" + id + "/va_release/" + releaseId + "/commit", data)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // uploadLibrary(agentId, params={}) {
  //   return this.http.post(environment.va_launcher_api + 'library_module/' + agentId + '/upload_library', params).map(
  //     (response: Response) => {
  //       return response;
  //     }, (err: Response) => {
  //       console.log(err);
  //       return err;
  //     }
  //   );
  // }
  uploadLibrary(agentId, params={}) {
    return this.http.post(environment.va_launcher_api + 'library_module/' + agentId + '/upload_library', params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // deleteLibrary(libraryId) {
  //   return this.http.delete(environment.va_launcher_api + 'library_module/' + libraryId + '/delete_library').map(
  //     (response: Response) => {
  //       return response;
  //     }, (err: Response) => {
  //       console.log(err);
  //       return err;
  //     }
  //   );
  // }
  deleteLibrary(libraryId) {
    return this.http.delete(environment.va_launcher_api + 'library_module/' + libraryId + '/delete_library')
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  // getPaginatedReleases(agentId, limit, offset, search) {
  //   let url = environment.va_launcher_api + 'releases/' + agentId + '/paginated/va_release?limit=' + limit + '&offset=' + offset;
  //   if(search){
  //     url = url + "&search=" + search;
  //   }
  //   return this.http.get(url)
  //   .map(
  //     (response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       return err;
  //     });
  // }
  getPaginatedReleases(agentId, limit, offset, search) {
    let url = environment.va_launcher_api + 'releases/' + agentId + '/paginated/va_release?limit=' + limit + '&offset=' + offset;
    if (search) {
      url = url + "&search=" + search;
    }
    return this.http.get(url).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  // getLaunchedRelease(agentId) {
  //   return this.http.get(environment.va_launcher_api + 'releases/' + agentId + '/launched-release').map(
  //     (response: Response) => {
  //       return response;
  //     }, (err: Response) => {
  //       return err;
  //     }
  //   );
  // }
  getLaunchedRelease(agentId) {
    return this.http.get(environment.va_launcher_api + 'releases/' + agentId + '/launched-release')
      .pipe(
        catchError((err) => {
          return throwError(err);
        })
      );
  }

}
